import React from 'react';
import "./No_cost_emi_offer.css";
import { useNavigate } from 'react-router-dom';

function No_cost_emi_offer() {
  const navigate = useNavigate();
  return (
    <div className="No_cost_emi_offer_container">
      <h4>No Cost EMI Offer</h4>
      <div className="No_cost_emi_offer_product_grid">
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2024/05/AVAIL-NO-COST-EMI-1536x153.png' className="img-fluid" />
      </div>
    </div>
  );
}


export default No_cost_emi_offer;